export default "__VITE_ASSET__DdP36qA1__"